<form
  class="fadeInLeft animated faster position-relative"
  (ngSubmit)="login()"
  [formGroup]="form"
  *ngIf="{ isLoading: isLoading$ | async } as state"
>
  <div>
    <div class="pb-2 pt-4">
      <div class="form-group">
        <py-reactive-form-input-field
          [group]="form"
          [label]="'login.username_heading' | cxTranslate"
          [resettable]="true"
          fieldName="userId"
          [includeGroupErrors]="true"
          (handleReset)="onResetInput('userId')"
        ></py-reactive-form-input-field>
      </div>
      <div class="form-group pt-2">
        <py-reactive-form-input-field
          [group]="form"
          [label]="'login.password_heading' | cxTranslate"
          [resettable]="true"
          fieldName="password"
          [includeGroupErrors]="true"
          inputType="password"
          (handleReset)="onResetInput('password')"
        >
        </py-reactive-form-input-field>
      </div>
    </div>
    <py-action-button
      class="d-block"
      [buttonClass]="'btn btn-primary btn-block animated'"
      [disabled]="(form.invalid && !form.dirty) || state.isLoading || (disableLogin$ | async)"
      [loading]="state.isLoading"
      [buttonLabel]="'login.signIn_action' | cxTranslate"
      [type]="'submit'"
      [@shakeState]="shakeState"
    >
    </py-action-button>
    <button type="button" (click)="changeLoginPageView(loginFormView.ForgotPassword)" class="btn btn-ternary btn-block mt-2">
      {{ 'login.forgotPassword_action' | cxTranslate }}
    </button>
    <button type="button" (click)="changeLoginPageView(loginFormView.ForgotUsername)" class="btn btn-ternary btn-block mt-2">
      {{ 'login.forgotUsername_action' | cxTranslate }}
    </button>
  </div>
</form>
